// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 2432) return "async/2432.js";
	if (chunkId === 7586) return "async/7586.js";
	// return url for filenames based on template
	return undefined;
};